import { getRunTypeName } from '@/utils/get-run-type-name';
import { cn } from '@/utils/tailwind';

import { RunSchema } from '../types/schema';
import { getRunTypeClassName } from './RunType.utils';

export function RunTypeChip({
  run,
  className,
  size = 'xs',
}: {
  run?: RunSchema;
  className?: string;
  size?: 'xs' | 'sm';
}) {
  return (
    <div
      className={cn(
        'inline-flex w-auto items-center rounded-md capitalize leading-none',
        getRunTypeClassName(run),
        {
          'px-1 py-0.5 text-xs': size === 'xs',
          'px-1.5 py-0 text-sm': size === 'sm',
        },
        className
      )}
    >
      {getRunTypeName(run)}
    </div>
  );
}
